module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/section05_01_american-village-b3a1410c38d887924432c4da6d19e47a.jpg";